/* global axios */
import ApiClient from '../../ApiClient';

class StackzapCallsAPI extends ApiClient {
  constructor() {
    super('stackzap_calls', { accountScoped: true });
  }

  show(callId) {
    return axios.get(`${this.url}/${callId}`).then(r => r.data);
  }

  initiate(conversationId) {
    return axios
      .post(`${this.url}/initiate`, {
        conversation_id: conversationId,
      })
      .then(r => r.data);
  }

  accept(callId) {
    return axios.post(`${this.url}/${callId}/accept`).then(r => r.data);
  }

  reject(callId) {
    return axios.post(`${this.url}/${callId}/reject`).then(r => r.data);
  }

  terminate(callId) {
    return axios.post(`${this.url}/${callId}/terminate`).then(r => r.data);
  }
}

export default new StackzapCallsAPI();
